import Image from "next/image";
import docIcon from "@/assets/images/proactive-ai/doc-icon.svg";
import voiceIcon from "@/assets/images/proactive-ai/voice-icon.svg";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import boxBgImage from "@/assets/images/proactive-ai/box-bg.svg";
import docImage from "@/assets/images/proactive-ai/document.svg";
import voiceImage from "@/assets/images/proactive-ai/voice.svg";
import enterpriseImage from "@/assets/images/proactive-ai/enterprise.svg";

const cardsData = [
  {
    icon: docIcon,
    title: "Source-Backed",
    description:
      "Every decision Kroolo makes links back to your original docs or chats for complete accountability and trust.",
    image: docImage,
    alt: "Source-backed card",
  },
  {
    icon: voiceIcon,
    title: "Human-in-the-Loop",
    description:
      "Kroolo acts as your team's most capable assistant, not a replacement. You stay in control with built-in guardrails.",
    image: voiceImage,
    alt: "Human in the loop card",
  },
  {
    icon: docIcon,
    title: "Safe & Secure",
    description:
      "Built for the organization from the ground up. Predictable workflows designed to meet strict business security standards.",
    image: enterpriseImage,
    alt: "Safe and secure card",
  },
] as const;

const BuiltCards = () => {
  return (
    <>
      <section className="bg-[#EFEFF6] py-16 xl:py-28">
        <div className="container mx-auto px-4">
          <div className="mb-8 text-center xl:mb-10">
            <h2 className="mx-auto mb-3 max-w-[500px] text-[24px] font-semibold text-[#202020] lg:text-[32px]">
              Built for teams,{" "}
              <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                not just demos.
              </span>
            </h2>
            <CommonSubtitle
              color="#717171"
              fontSizeWeight="text-[14px] lg:text-[16px] font-normal max-w-[900px] mx-auto"
            >
              Move beyond simple chat. Kroolo AI is integrated into your data
              structure, enabling deep reasoning and autonomous action across
              your entire organization.
            </CommonSubtitle>
          </div>
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
            {cardsData.map((card) => (
              <div
                key={card.title}
                className="flex h-full flex-col justify-between rounded-3xl p-6 text-left text-white lg:p-7"
                style={{
                  backgroundImage: `url(${boxBgImage.src})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="mb-5">
                  <div className="mb-4">
                    <Image
                      src={card.icon}
                      alt={card.title}
                      width={40}
                      height={40}
                    />
                  </div>
                  <h3 className="mb-2 text-[18px] font-medium lg:text-[22px]">
                    {card.title}
                  </h3>
                  <p className="text-[14px] leading-relaxed text-[#F3F3F8] lg:text-[16px]">
                    {card.description}
                  </p>
                </div>
                <div className="relative mt-auto">
                  <div className="overflow-hidden">
                    <Image
                      src={card.image}
                      alt={card.alt}
                      className="h-full w-full object-cover"
                      priority={card.title === "Source-Backed"}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BuiltCards;
